import * as React from "react";
const RequestsView = React.lazy(() => import("src/views/SupportView/SupportViewContainer"));

export { RequestsView };
